import angular from 'angular'
import './channel.service'
import './users/users.controller'
import './edition/edition.controller'
import './translation/translation.controller'
import './related/related.controller'

angular
  .module('pub.channel', [
    'pub.channel_users',
    'pub.channel.edition',
    'pub.channels.service',
    'pub.product_lines',
    'pub.channel.translation',
  ])
  .controller('ChannelCtrl', ChannelCtrl)

/** @ngInject */
function ChannelCtrl($rootScope, $scope, $state, $timeout, ChannelsService, CacheService) {
  $rootScope.page = 'page'
  var vm = this
  vm.loading = true
  vm.items = []
  vm.filter = 'Date: Newest'
  vm.sort = ['Date: Newest', 'Date: Oldest']
  vm.msgErrorBool = false
  vm.sortType = 'ts-p-desc'
  vm.sortReverse = false
  vm.title = ''
  vm.filterOnSale = false
  vm.search = ''
  vm.running = false

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.perPage = 20
    vm.currentPage = 20
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  vm.sortBy = function () {
    switch (vm.filter) {
      case 'Date: Newest':
        break
      case 'Date: Oldest':
        break
    }
  }

  vm.showModal = function () {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function () {
      $('#inputChannel').focus()
    })
  }

  var oldSortType
  function load(pageNumber) {
    if (vm.running) {
      return
    }
    vm.running = true
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 20
      vm.oldPage = vm.currentPage - 20
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    let sort = vm.sortType
    ChannelsService.list(vm.search, vm.oldPage, 20, sort, vm.filterOnSale).then(function (result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i]['ts-p'] !== undefined && result.results[i]['ts-p'] !== null) {
          result.results[i]['ts-p'] = new Date(
            parseInt(
              result.results[i]['ts-p']
                .toString()
                .substring(0, result.results[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          result.results[i]['ts-p'] = ''
        }

        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        } else if (result.results[i].st === 2) {
          result.results[i].status = 'Sold Out'
        } else if (result.results[i].st === 3) {
          result.results[i].status = 'Unavailable'
        } else if (result.results[i].st === 4) {
          result.results[i].status = 'Awaiting Collectible Count'
        } else if (result.results[i].st === 5) {
          result.results[i].status = 'Coming Soon'
        }
      }

      vm.sortType = oldSortType
      vm.items = result.results
      vm.loading = false
      vm.running = false
    })
  }

  load()

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    load(newPage)
  }

  CacheService.urls('', '', true)

  vm.saveChannel = function () {
    if (vm.title === '' || vm.title === undefined) {
      vm.msgError = 'Title: non zero value required'
      vm.msgErrorBool = true
      return
    }
    if (vm.title.length <= 2) {
      vm.msgError = 'Title: needs at least 3 characters'
      vm.msgErrorBool = true
      return
    }
    $('#myModal').modal('hide')
    $('#myModal').on('hidden.bs.modal', function () {
      ChannelsService.save({ t: vm.title, 'id-gen': vm['id-gen'] }).then(function (result) {
        $state.go('pub.channels.edit', { id: result.results.id })
      })
    })
  }

  vm.publish = function (state, item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want publish this channel',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (state) {
            ChannelsService.publish(item.id).then(
              function () {
                item.st = 1
                swal('Published', '', 'success')
                reloadPagination()
                load(1)
              },
              function (err) {
                var e = err.error.message.split(';')
                var html = ''
                for (var i = 0; i < e.length; i++) {
                  html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
                }
                swal({
                  title: 'Channel Incomplete',
                  text: html,
                  html: true,
                })
              },
            )
          } else {
            ChannelsService.unpublish(item.id).then(function () {
              item.st = 0
              swal('Unpublish', '', 'success')
            })
          }
        }
      },
    )
  }

   vm.changeOrder = function (item, currentList) {
    console.log('clicked');
    vm.order = null
    vm.currentItem = item
    vm.currentList = currentList || []
    $('#myModalOrder').modal('show')
  }


  vm.saveOrder = function () {
    if (!vm.order) {
      $timeout(function () {
        swal('Field required', '', 'error')
      }, 300)
      return
    }

    ChannelsService.reorder(vm.currentItem.id, parseInt(vm.order)).then(
      function () {
        $('#myModalOrder').modal('hide')
        load(1)
      },
      function (err) {
        $timeout(function () {
          swal(err.error.message, '', 'error')
        }, 300)
      },
    )
  }

  vm.sort = function (type) {
    vm.sortReverse = !vm.sortReverse
    vm.sortCurtom = false
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }
    reloadPagination()
    load(1)
  }

  vm.deleteChannel = function (item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want delete this channel',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelsService.remove(item.id).then(
            function () {
              swal('Deleted with success', '', 'success')
              reloadPagination()
              vm.sortType = 'ts-p-desc'
              load(1)
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              swal({
                title: 'Channel Incomplete',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  vm.bundle = function (item) {
    $state.go('pub.bundles', {
      parentId: 0,
      channelId: item.id,
    })
  }

  vm.clone = function (item) {
    swal(
      {
        title: 'Are you sure ?',
        text: 'You want clone this channel',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelsService.clone(item.id).then(
            function () {
              swal('Cloned with success', '', 'success')
              reloadPagination()
              vm.sortType = 'ts-p-desc'
              load(1)
            },
            function (err) {
              var e = err.error.message.split(';')
              var html = ''
              for (var i = 0; i < e.length; i++) {
                html += '<p style="color:red; font-size:14px; font-weigth:100;">' + e[i] + '</p>'
              }
              swal({
                title: 'Error for Clone this channel',
                text: html,
                html: true,
              })
            },
          )
        }
      },
    )
  }

  var watch = $scope.$watch('vm.search', function (newVal, oldVal) {
    if (newVal === oldVal) {
      return
    }

    if (newVal === null || newVal === '') {
      if (oldVal) {
        vm.sortType = oldSortType
        reloadPagination()
        load(1)
      }
      return
    }

    if (newVal === false) {
      return
    }

    if (vm.search.length < 2) {
      return
    }

    reloadPagination()
    load(1)
  })

  $scope.$on('$destroy', function () {
    watch()
  })

  vm.publishComingSoon = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: 'Do you want make this Channel coming soon?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelsService.publishComingSoon(item.id).then(function () {
            toastr.success('Published!')
            vm.sortType = oldSortType
            reloadPagination()
            load(1)
          })
        }
      },
    )
  }

  vm.closeStore = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: 'This will mark the store as Closed, and archive all Bundles currently on sale',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          ChannelsService.closeStore(item.id, { 'ts-close': new Date() }).then(function () {
            toastr.success('Store closed!')
            vm.sortType = oldSortType
            reloadPagination()
            load(1)
          })
        }
      },
    )
  }

  vm.waitlist = function (item) {
    $state.go('pub.channels.sets.waitlist', {
      parentId: $stateParams.parentId,
      id: item.id,
    })
  }

  vm.clickOnSale = function () {
    reloadPagination()
    load(1)
  }

  vm.genres = []
  ChannelsService.listGenres().then(function (result) {
    vm.genres = result.results
  })

  vm.fixLeaderboard = function (item) {
    ChannelsService.fixLeaderboards(item.id).then(
      function () {
        toastr.success('Fixed!')
      },
      function () {
        toastr.error('Try again!')
      },
    )
  }
}
